<template>
	<div class="row">
	     <div class="col-md-12">


	     	<div class="row justify-content-center align-items-center min-vh" v-if="loading == true">
		        <div class="col-md-12 text-center">
		            <div class="d-flex justify-content-center" >
		            	<div class="align-self-center flex-grow-1">
		            		<div class="spinner-border" role="status">
					          <span class="sr-only">Loading...</span>
					        </div>
		            	</div>
		            </div>
		        </div>
		    </div>

		    <div class="row   min-vh" v-else>
		    	<div class="col-md-12">
		    		 <section class="content-inner" >
			        	<div class="card">
							<div class="card-header py-0 ">
								<h4 class="card-title"><span>Search:</span><b> {{ q }}</b></h4>
							</div>
							<div class="card-body p-0" v-if="items.length > 0">
								<div class="d-none d-md-block">
									<div class="d-flex flex-row">
										<div>
											<button class="toolbar-action border-right" @click="goBack">Back</button>
										</div>
										<div>
											<button class="toolbar-action border-right" @click="selectAll">Select All</button>
										</div>
										<div>
											<button class="toolbar-action border-right" @click="zipAllItem($event)">Download All (Zip)</button>
										</div>
                    <div v-if="items.length > 0 && items_selected.length > 0">
                      <button v-if="items_selected.length == 1 && items_selected[0].type == 'file'" class="toolbar-action border-right" @click="downloadURL(items_selected[0].link)">Download Selected</button>
                      <button v-else-if="items_selected.length == 1 && items_selected[0].type == 'folder'" class="toolbar-action border-right" @click="zipMultipleItem($event)">Download Selected (Zip)</button>
                      <button v-else class="toolbar-action border-right" @click="zipMultipleItem($event)">Download Selected (Zip)</button>
                    </div>
						            </div>
								</div>
								<div class="d-md-none">
									<div class="d-flex flex-column">
										<div class=" border-bottom text-center">
											<button  class="toolbar-action w-100" @click="goBack">Back</button>
										</div>
										<div class=" border-bottom text-center">
											<button  class="toolbar-action  w-100" @click="selectAll">Select All</button>
										</div>
										<div class=" border-bottom text-center">
											<button  class="toolbar-action  w-100" @click="zipOneItem($event,folder_id)">Download All (Zip)</button>
										</div>
                    <div class="text-center" v-if="items.length > 0 && items_selected.length > 0">
                      <button v-if="items_selected.length == 1 && items_selected[0].type == 'file'" class="toolbar-action w-100" @click="downloadURL(items_selected[0].link)">Download Selected</button>
                      <button v-else-if="items_selected.length == 1 && items_selected[0].type == 'folder'" class="toolbar-action w-100" @click="zipMultipleItem($event)">Download Selected (Zip)</button>
                      <button v-else class="toolbar-action w-100" @click="zipMultipleItem($event)">Download Selected (Zip)</button>
                    </div>
						      </div>
								</div>
							</div>
						</div>
						<div class="card">
							<div class="card-body  px-5">
								<div class="row">
									<div class="col-md-12 text-center p-5" v-if="!items.length || items.length == 0">
						                <svg class="icon icon-folder-empty pb-3"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-folder-empty"></use></svg>
						                <h3 class="mb-3"><b>No results</b></h3>
						                <p class="text-muted">We couldn't find what you're looking for</p>
						                
						            </div>
						            <div class="col-md-12 directory-grid" v-else>
						              <div class="row no-gutters row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-5"  v-if="mobile">
						                  <div class="col-sm directory-grid-box rounded-0 border-0" v-for="(item, index) in filteredItems" v-bind:class="{'is-checked' : items_selected.includes(item) == true, '' : items_selected.includes(item) == false, 'is-folder' :item.type == 'folder', 'is-file' : item.type == 'file'}" :id="item.id">
						                    <span v-if="item.type == 'folder'" >
						                      <a :href="'/files?folder_id='+item.id">
						                      <div class="directory-grid-box-thumb">
						                        <div class="directory-grid-box-thumb-content">
						                          <div class="directory-grid-box-icon">
						                            <svg class="icon icon-folder"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-folder"></use></svg> 
						                          </div>
						                        </div>
						                      </div>

						                      <div class="directory-grid-box-name ">
						                        <h2>{{item.name}}</h2>
						                      </div>
						                      </a>

						                      <label class="directory-grid-box-checkbox">
						                        <input type="checkbox" class="checkbox" v-model="items_selected" @click="select" :value="item">
						                        <span></span>
						                      </label>
						                    </span>
						                    <span v-else >
						                     <a :href="'/file?id='+item.id">
						                      <div class="directory-grid-box-thumb">
						                        <div class="directory-grid-box-thumb-content">
						                          <div class="directory-grid-box-icon">
						                            <svg class="icon icon-play-circle" v-if="item.mime_type.includes('video')"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-play-circle"></use></svg>
						                            <div v-else class="file-icon file-icon-lg">
						                              <div class="file-icon-bg">
						                                  <svg class="icon icon-file"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-file"></use></svg>
						                              </div>
						                              <div class="file-icon-type" >
						                                <svg class="icon icon-doc" v-if="item.name.includes('.txt')"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-doc"></use></svg>
						                                <svg class="icon icon-image" v-if="item.mime_type.includes('image')"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-image"></use></svg>
						                                <svg class="icon icon-music" v-if="item.mime_type.includes('audio')"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-music"></use></svg>
						                              </div>
						                            </div>
						                          </div>
						                        </div>
						                      </div>
						                      <div class="directory-grid-box-name ">
						                        <h2>{{item.name}}</h2>
						                      </div>
						                      <div class="directory-grid-box-size">{{item.size | humanFileSize}}</div>
						                       </a>
		
						                      <label class="directory-grid-box-checkbox">
						                        <input type="checkbox" class="checkbox" v-model="items_selected" @click="select" :value="item">
						                        <span></span>
						                      </label>
						                    </span>
						                  </div>
						                </div>
						                <div class="row no-gutters row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-5" v-else>
						                  <div  class="col-sm directory-grid-box rounded-0 border-0" v-for="(item, index) in filteredItems" v-bind:class="{'is-checked' : items_selected.includes(item) == true, '' : items_selected.includes(item) == false, 'is-folder' :item.type == 'folder', 'is-file' : item.type == 'file'}" :id="item.id" >
						                    <span v-if="item.type == 'folder'" >
						                      <a :href="'/files?folder_id='+item.id">
						                      <div class="directory-grid-box-thumb">
						                        <div class="directory-grid-box-thumb-content">
						                          <div class="directory-grid-box-icon">
						                            <svg class="icon icon-folder"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-folder"></use></svg> 
						                          </div>
						                        </div>
						                      </div>

						                      <div class="directory-grid-box-name ">
						                        <h2>{{item.name}}</h2>
						                      </div>
						                      </a>
						                      <label class="directory-grid-box-checkbox">
						                        <input type="checkbox" class="checkbox" v-model="items_selected" @click="select" :value="item">
						                        <span></span>
						                      </label>
						                    </span>
						                    <span v-else >
						                     <a :href="'/file?id='+item.id">
						                      <div class="directory-grid-box-thumb">
						                        <div class="directory-grid-box-thumb-content">
						                          <div class="directory-grid-box-icon">
						                            <svg class="icon icon-play-circle" v-if="item.mime_type.includes('video')"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-play-circle"></use></svg>
						                            <div v-else class="file-icon file-icon-lg">
						                              <div class="file-icon-bg">
						                                  <svg class="icon icon-file"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-file"></use></svg>
						                              </div>
						                              <div class="file-icon-type" >
						                                <svg class="icon icon-doc" v-if="item.name.includes('.txt')"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-doc"></use></svg>
						                                <svg class="icon icon-image" v-if="item.mime_type.includes('image')"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-image"></use></svg>
						                                <svg class="icon icon-music" v-if="item.mime_type.includes('audio')"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-music"></use></svg>
						                              </div>
						                            </div>
						                          </div>
						                        </div>
						                      </div>
						                      <div class="directory-grid-box-name ">
						                        <h2>{{item.name}}</h2>
						                      </div>
						                      <div class="directory-grid-box-size">{{item.size | humanFileSize}}</div>
						                       </a>
						                      <label class="directory-grid-box-checkbox">
						                        <input type="checkbox" class="checkbox" v-model="items_selected" @click="select" :value="item">
						                        <span></span>
						                      </label>
						                    </span>
						                  </div>
						              </div>
						            </div>
								</div>
							</div>
						</div>
			        </section>
		    	</div>
		    </div>
	       	
	    </div>
         <div class="modal fade" id="zipModal" tabindex="-1" role="dialog" aria-labelledby="zipModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h6 class="modal-title">Zip Download</h6>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="col-md-12 p-2 text-center" v-if="!zip_data.finish">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <div v-else class="text-center">
                      <div class="alert alert-danger" role="alert" v-if="zip_data.error != null">
                        {{zip_data.error}}
                      </div>
                      <div v-else class="row">
                        <div class="col-12 col-md-6 offset-md-3">
                          <a :href="zip_data.link" class="btn btn-primary btn-block my-1">Start to download</a>
                        </div>
                        <div class="col-12 col-md-6 offset-md-3"> 
                          <button type="button" class="btn btn-primary btn-border btn-block  my-1" v-tooltip:top="'Copy download link'" @click="copyToClipboard"><i class="fas fa-copy"></i> Copy link</button>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="modal-footer">
					<button type="button" class="btn btn-secondary pull-right" data-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
        </div>
	</div>


   
</template>
    
<script>
    
    import dayjs from 'dayjs';
    import relativeTime from 'dayjs/plugin/relativeTime';
    import customParseFormat from 'dayjs/plugin/customParseFormat';

    export default {
        props: ['message','is_premium'],
        data() {
            return {
                q: this.getParameterFromUrl('q'),
                items: {},
                selected: [],
                allSelected: false,
                items_selected: [],
                selected_item: {},
                zip_data: { link: null, finish: false, error: null },
                mobile:window.innerWidth <= 1024,
                loading: true
            }
        },
        created() {
            dayjs.extend(relativeTime);
            dayjs.extend(customParseFormat);
            addEventListener('resize', () => {
              this.mobile = innerWidth <= 1024
            })
        },
        filters: {
            diffForHumans: (date) => {
                if (!date){
                    return null;
                }

                if(dayjs(date,'YYYY-MM-DD HH:hh:ss').isValid()){
                    return dayjs(date).fromNow();
                } else {
                    return dayjs.unix(date).fromNow();
                }
                
               
            },
            humanFileSize: (bytes) => {
                var thresh = 1024;
                if(Math.abs(bytes) < thresh) {
                    return bytes + ' B';
                }
                var units = ['KB','MB','GB','TB','PB','EB','ZB','YB'];
                var u = -1;
                do {
                    bytes /= thresh;
                    ++u;
                } while(Math.abs(bytes) >= thresh && u < units.length - 1);
                return bytes.toFixed(1)+' '+units[u];
            },

        },
        computed: {
            filteredItems() {
              let tempItems = this.items
                    
                  tempItems = tempItems.sort((a, b) => {
                      if (this.sortBy == 'name') {
                          let fa = a.name.toLowerCase(), fb = b.name.toLowerCase()
                    
                        if (fa < fb) {
                          return -1
                        }
                        if (fa > fb) {
                          return 1 
                        }
                        return 0
                        
                        // Sort by date
                      } else if (this.sortBy == 'date') {
                         return b.created_at - a.created_at;
                        //return new Date(a.created_at) - new Date(b.created_at);
                      } else if (this.sortBy == 'size') {
                        var a = (a.size ? a.size : 0);
                        var b = (b.size ? b.size : 0);
                        return a - b;
                      }
                  })
                  
                  // Show sorted array in descending or ascending order
                  if (!this.ascending || this.ascending == 'false') {
                    tempItems.reverse();
                  }
                  
                  return tempItems
            }
        },
        
        mounted() {
          this.listResult();
        },
        methods: {
        	isMobile(){
              return /Mobi|Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },
            getParameterFromUrl: function(param){
                var result = null,
                  tmp = [];
                var items = location.search.substr(1).split("&");
                for (var index = 0; index < items.length; index++) {
                  tmp = items[index].split("=");
                  if (tmp[0] === param) result = decodeURIComponent(tmp[1]);
                }
                return result
            },
            goBack: function() {
            	if (document.referrer == "") {
				   window.location.href = '/transfers'; 
				} else {
				    history.back()
				}
            },
            selectAll: function() {
                this.allSelected = !this.allSelected; 

                this.items_selected = [];               
                if (this.allSelected) {
                    for(var i = 0; i < this.items.length; i++) {
                        this.items_selected.push(this.items[i]);
                    }

                }
               
            },
            select: function() {
                this.allSelected = false;
            },
            copyToClipboard(){
              if (window.clipboardData && window.clipboardData.setData) {
                // IE specific code path to prevent textarea being shown while dialog is visible.
                return clipboardData.setData("Text", this.zip_data.link);

              } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                var textarea = document.createElement('textarea');
                textarea.textContent = this.zip_data.link;
                document.body.appendChild(textarea);
                var selection = document.getSelection();
                var range = document.createRange();
                range.selectNode(textarea);
                selection.removeAllRanges();
                selection.addRange(range);
                try {
                  return document.execCommand("copy"); // Security exception may be thrown by some browsers.
                } catch (ex) {
                  console.warn("Copy to clipboard failed.", ex);
                  return false;
                } finally {
                  selection.removeAllRanges();
                  document.body.removeChild(textarea);
                }
              }
            },
            listResult(){
                axios.post('/api/folder/search',{search : this.q}).then(response=>{
                	this.loading = false;
	          		this.items = response.data.content;
	          		console.log(this.items.length);
		        }).catch(error=>{
		          console.log(error);
		        });
            },
            zipAllItem(e) {
              	this.zip_data =  { link: null, finish: false, error: null };
              	//e.target.disabled = true;
              	$('#zipModal').modal('toggle');
              	//e.target.innerHTML = '<svg class="icon icon-cloud-download"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-cloud-download"></use></svg> GENERATING ZIP FILE';

              	var foldersItems = []; 
	            var filesItems = [];

	            for(var i = 0; i < this.items.length; i++) {
	              if(this.items[i].type == 'folder'){
	                foldersItems.push(this.items[i].id);
	              }else if(this.items[i].type == 'file'){
	                filesItems.push(this.items[i].id);
	              }
	            }

	            console.log(foldersItems,filesItems)

				axios.post('/api/zip/generate',{'file_ids': filesItems,'folder_ids': foldersItems}).then(response=>{
				  e.target.disabled = false;
				  //this.zip_finish = true;
				  //e.target.innerHTML = '<svg class="icon icon-cloud-download"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-cloud-download"></use></svg> DOWNLOAD THIS FOLDER AS A ZIP FILE';
				  if(response.data.status == 'success'){
				     //flash('Zip successfully generated, opening new tab for downloading.', 'success');
				    //this.zip_link = response.data.location;
				    this.zip_data = { link: response.data.location, finish: true, error: null };
				  }

				}).catch(error=>{
				  //e.target.disabled = false;
				  this.zip_data = { link: null, finish: true, error:  JSON.parse(error.request.response).message };
				  //e.target.innerHTML = '<svg class="icon icon-cloud-download"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-cloud-download"></use></svg> DOWNLOAD THIS FOLDER AS A ZIP FILE';
				  //flash(JSON.parse(error.request.response).message, 'error');
				});
            },
            zipOneItem(e,folder_id) {
              this.zip_data =  { link: null, finish: false, error: null };
              //e.target.disabled = true;
              $('#zipModal').modal('toggle');
              //e.target.innerHTML = '<svg class="icon icon-cloud-download"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-cloud-download"></use></svg> GENERATING ZIP FILE';
              axios.post('/api/zip/generate',{'folder_ids': [folder_id]}).then(response=>{
                  e.target.disabled = false;
                  //this.zip_finish = true;
                  //e.target.innerHTML = '<svg class="icon icon-cloud-download"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-cloud-download"></use></svg> DOWNLOAD THIS FOLDER AS A ZIP FILE';
                  if(response.data.status == 'success'){
                     //flash('Zip successfully generated, opening new tab for downloading.', 'success');
                    //this.zip_link = response.data.location;
                    this.zip_data = { link: response.data.location, finish: true, error: null };
                  }

              }).catch(error=>{
                  //e.target.disabled = false;
                  this.zip_data = { link: null, finish: true, error:  JSON.parse(error.request.response).message };
                  //e.target.innerHTML = '<svg class="icon icon-cloud-download"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-cloud-download"></use></svg> DOWNLOAD THIS FOLDER AS A ZIP FILE';
                  //flash(JSON.parse(error.request.response).message, 'error');
              });



            },
            zipMultipleItem(e){
              this.zip_data =  { link: null, finish: false, error: null };
              //e.target.disabled = true;
              $('#zipModal').modal('toggle');
              //e.target.innerHTML = '<svg class="icon icon-cloud-download"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-cloud-download"></use></svg> GENERATING ZIP FILE';
                var foldersItems = []; 
                var filesItems = [];

                for(var i = 0; i < this.items_selected.length; i++) {
                  if(this.items_selected[i].type == 'folder'){
                    foldersItems.push(this.items_selected[i].id);
                  }else if(this.items_selected[i].type == 'file'){
                    filesItems.push(this.items_selected[i].id);
                  }
                }

              axios.post('/api/zip/generate',{'file_ids': filesItems,'folder_ids': foldersItems}).then(response=>{
                  e.target.disabled = false;
                  //e.target.innerHTML = '<svg class="icon icon-cloud-download"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-cloud-download"></use></svg> DOWNLOAD SELECTED AS ZIP <span class="badge badge-pill badge-success">'+this.items_selected.length+'</span>';
                  if(response.data.status == 'success'){
                     //flash('Zip successfully generated, opening new tab for downloading.', 'success');
                    this.zip_data = { link: response.data.location, finish: true, error: null };
                  } 

              }).catch(error=>{
                  //e.target.disabled = false;
                  this.zip_data = { link: null, finish: true, error:  JSON.parse(error.request.response).message };
                  //e.target.innerHTML = '<svg class="icon icon-cloud-download"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-cloud-download"></use></svg> DOWNLOAD SELECTED AS ZIP <span class="badge badge-pill badge-success">'+this.items_selected.length+'</span>';
                  //flash(JSON.parse(error.request.response).message, 'error');
              });
            },
            downloadURL(url){
              var iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              document.body.appendChild(iframe);
              iframe.src = url;
            }
        }
    }
</script>